import { LLMChannelTemplateContainer } from '@/modules/LLMChannelTemplate';

export const LLMChannelTemplate = (): JSX.Element => <LLMChannelTemplateContainer />;

export default LLMChannelTemplate;
